'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _trackEnums = require('./track-enums');

var _track = require('./track');

var _track2 = _interopRequireDefault(_track);

var _utilsMergeOptions = require('../utils/merge-options');

var _utilsMergeOptions2 = _interopRequireDefault(_utilsMergeOptions);

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

/**
 * A single audio text track as defined in:
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack
 *
 * interface AudioTrack {
 *   readonly attribute DOMString id;
 *   readonly attribute DOMString kind;
 *   readonly attribute DOMString label;
 *   readonly attribute DOMString language;
 *   attribute boolean enabled;
 * };
 *
 * @param {Object=} options Object of option names and values
 * @class AudioTrack
 */

var AudioTrack = (function (_Track) {
  _inherits(AudioTrack, _Track);

  function AudioTrack() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, AudioTrack);

    var settings = _utilsMergeOptions2['default'](options, {
      kind: _trackEnums.AudioTrackKind[options.kind] || ''
    });
    // on IE8 this will be a document element
    // for every other browser this will be a normal object
    var track = _Track.call(this, settings);
    var enabled = false;

    if (browser.IS_IE8) {
      for (var prop in AudioTrack.prototype) {
        if (prop !== 'constructor') {
          track[prop] = AudioTrack.prototype[prop];
        }
      }
    }

    Object.defineProperty(track, 'enabled', {
      get: function get() {
        return enabled;
      },
      set: function set(newEnabled) {
        // an invalid or unchanged value
        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
          return;
        }
        enabled = newEnabled;
        this.trigger('enabledchange');
      }
    });

    // if the user sets this track to selected then
    // set selected to that true value otherwise
    // we keep it false
    if (settings.enabled) {
      track.enabled = settings.enabled;
    }
    track.loaded_ = true;

    return track;
  }

  return AudioTrack;
})(_track2['default']);

exports['default'] = AudioTrack;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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